import React from 'react'

import { generateInvoicePdfs, getInvoiceSuppliers } from '../../../api'
import { InvoiceSuppliersTable } from './collectionTable';
import { PaginatedTable, PaginatedTableCallbacks, InsufficientPermissions } from '../../common'
import defineAbilityFor from '../defineAbility'
import { InvoiceBatchFilters } from './filters'
import { getAuthUser } from '../../../helpers';
import { SupplierInvoiceBatchRow, JsonSupplierInvoiceBatchRow } from '../../../models'

export const GenerateInvoicesLanding = () => {

    const ability = defineAbilityFor(getAuthUser())

    if (!ability.can('Create', 'InvoiceBatch')) {
        return <InsufficientPermissions />
    }

    return (
        <PaginatedTable<SupplierInvoiceBatchRow, JsonSupplierInvoiceBatchRow>
            getData={getInvoiceSuppliers}
            Filters={(props) => <InvoiceBatchFilters {...props} billingTypePermissions />}
            postLink={{
                request: generateInvoicePdfs,
                text: 'Generate Invoice PDFs',
            }}
            filterButton={{
                text: 'Filter Suppliers'
            }}
            disableAutoFilter={true}
            modelConstructor={(json: JsonSupplierInvoiceBatchRow) => new SupplierInvoiceBatchRow(json)}
            searchPlaceholder='Search by Name, Phone, Street Address, or City'
            Table={(suppliers: SupplierInvoiceBatchRow[], callbacks: PaginatedTableCallbacks) => (
                <InvoiceSuppliersTable
                    callbacks={callbacks}
                    resources={{suppliers}}
                />
            )}
            title='Suppliers'
        />
    )
}
